"use client";

import { initMixpanel } from "@/lib/mixpanel";
import { ReactNode, useEffect } from "react";

export function MixpanelProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    initMixpanel();
  }, []);
  return children;
}

export default MixpanelProvider;
